import FinTronConfig from '@fintronners/react-config/src/Config/FinTronConfig';

export default {
  profileSettings: {
    basicInformation: 'Basic information',
    address: 'Address',
    citizenshipStatus: 'Citizenship status',
    investorInformation: 'Investor information',
    riskProfile: 'Risk profile',
    saveSuccess: 'You have successfully submitted your changes.',
    saveError: `We were unable to save your changes. Please try again later. If the issue persists, contact ${FinTronConfig.supportEmail}.`,
  },
  bankLink: {
    title: 'Linked bank accounts',
    description: `Change or update your bank linkage by using Plaid. Select a bank account below or add a new account to enter Plaid.\n\nManage your linked bank accounts for ${FinTronConfig.robo.name} and ${FinTronConfig.selfDirected.name} by using Plaid, a third-party bank verification tool.`,
    account: '{{ account }} account',
    discretionaryDescription: '',
  },
  profileUpdates: {
    title: 'Update info',
    description: `This information update will be applied to all your open ${FinTronConfig.clearingFirm}. accounts, including those associated with ${FinTronConfig.robo.name} and ${FinTronConfig.selfDirected.name}.`,
    yesUpdate: 'Yes, Update',
  },
  security: {
    title: 'Security',
    password: 'Update password',
    twoFactorAuth: 'Two-factor Authentication',
    login: 'Login',
    loginDescription:
      'We will send you an email or text with the two-factor authentication code for each login.',
  },
  investmentQuestions: {
    title: 'Investment questions',
    notSure: "If you aren't sure, it likely doesn't apply.",
    experienceLevelQuestion: 'What is your investing level of experience?',
    annualIncomeOptions: {
      _025000: 'Less than or equal to $25,000',
      _2500150000: '$25,001-$50,000',
      _50001100000: '$50,001-$100,000',
      _100001200000: '$100,001-$200,000',
      _200001300000: '$200,001-$300,000',
      _300001500000: '$300,001-$500,000',
      _5000011000000: '$500,001-$1,000,000',
      _5000011200000: '$500,001-$1,200,000',
      _10000015000000: '$1,000,001-$5,000,000',
      _12000019999999: '$1,200,001-$9,999,999',
      _50000019999999: '$5,000,001-$9,999,999',
      Unspecified: 'Unspecified',
    },
    netWorthOptions: {
      _025000: 'Less than or equal to $25,000',
      _050000: 'Less than or equal to $50,000',
      _2500150000: '$25,001-$50,000',
      _50001100000: '$50,001-$100,000',
      _100001200000: '$100,001-$200,000',
      _200001300000: '$200,001-$300,000',
      _200001500000: '$200,001-$500,000',
      _300001500000: '$300,001-$500,000',
      _5000011000000: '$500,001-$1,000,000',
      _10000015000000: '$1,000,001-$5,000,000',
      _50000019999999: '$5,000,001-$9,999,999',
      Unspecified: 'Unspecified',
    },
    netWorthRangeInfoTitle: 'Finding Your Net Worth',
  },
  investorInformation: {
    investing: 'Investing',
    personal: 'Personal',
    compliance: 'Compliance',
    investmentExperience: 'Investment experience',
    investmentObjective: 'Investment objective',
    investmentTimeHorizon: 'Investment time horizon',
    importanceOfCashOnHand: 'Importance of cash on hand',
    marriageStatus: 'Marriage status',
    employmentStatus: 'Employment status',
    annualIncome: 'Annual income',
    netWorth: 'Net worth',
  },
};
